var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": "1.16rem" } },
    [
      _c("topbar", { attrs: { text: "意见反馈" } }),
      _vm._v(" "),
      _c("div", { staticClass: "textareaBox" }, [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.content,
              expression: "content"
            }
          ],
          attrs: {
            maxlength: "256",
            cols: "30",
            rows: "10",
            placeholder: "请输入您的意见或建议!"
          },
          domProps: { value: _vm.content },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.content = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "numBox" }, [
          _vm._v(_vm._s(_vm.content.length) + "/256")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btnBox", on: { click: _vm.send } }, [
        _vm._v("提交")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-91b125d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91b125d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/feedback.vue
// module id = null
// module chunks = 